import { Flex } from "@chakra-ui/react";
import { IconAppWindow } from "@tabler/icons-react";
import { NavGroup, NavItemProps } from "am-tax-fe-core";

import { Application, NavItemResponse } from "../../../api";
import { NavDestination } from "../../../types/enums";

export type NavItemExtended = NavItemResponse & { subNavs: NavItemExtended[] | undefined; applicationTemplateId?: string | undefined };
export type NavItemPropsExtended = NavItemProps & { leftColor?: string | undefined };

interface DynamicNavItemProps {
    navItem: NavItemResponse;
    engagementId?: string;
    projectId?: string | undefined;
    leftIndent?: string | undefined;
    appColor?: string | undefined;
}

export function getDynamicNavItem({ navItem, engagementId, projectId, leftIndent, appColor }: DynamicNavItemProps): NavItemPropsExtended {
    let to = "";
    if (navItem?.destination === NavDestination.Iframe) {
        if (engagementId && projectId) {
            to = `/engagement/${engagementId}/project/${projectId}/navItem/${navItem.id}`;
        } else if (engagementId) {
            to = `/engagement/${engagementId}/navItem/${navItem.id}`;
        } else {
            to = `/navItem/${navItem.id}`;
        }
    } else {
        to = navItem?.href;
    }
    return {
        to,
        leftIcon: <IconAppWindow size="1rem" />,
        text: navItem?.linkText,
        leftColor: appColor,
        itemDefaults: leftIndent ? { indent: leftIndent } : {},
    };
}

export const getNavItem = (navItem: NavItemExtended | null, engagementId: string, projectId: string | undefined, applications: Application[]) => {
    const hasChildren = navItem?.subNavs && navItem?.subNavs.length > 0;
    if (hasChildren) {
        const firstSubItem = navItem?.subNavs?.[0];
        const appColor = applications?.find(x => x?.applicationTemplateId === firstSubItem?.applicationTemplateId)?.appColor;

        const itemDefaults = projectId ? { hoverColor: "whiteAlpha.200", activeColor: "blue.400" } : { hoverColor: "greenAlpha.400", activeColor: "green.500" };
        const navGroup: NavGroup = {
            isGroup: true,
            isAccordion: true,
            groupColor: appColor ?? "green.500",
            groupMargin: "0",
            groupPadding: "0 1rem 0 0",
            itemDefaults,
            groupHeading: (
                <Flex px="1rem" py=".5rem" gap=".5rem" align="center" color="white">
                    <IconAppWindow size="16px" />
                    {navItem?.linkText}
                </Flex>
            ),
            items: [],
        };

        if (navItem?.subNavs && navItem?.subNavs.length) {
            for (const subNavItem of navItem.subNavs) {
                navGroup.items.push(getDynamicNavItem({ navItem: subNavItem, engagementId, leftIndent: "0.5rem" }));
            }
        }

        return navGroup;
    } else {
        if(!navItem) return null;
        const appColor = applications?.find(x => x?.applicationTemplateId === navItem?.applicationTemplateId)?.appColor || undefined;
        return getDynamicNavItem({ navItem: navItem, engagementId, appColor });
    }
};
